import {Alert, Hyperlink} from 'platform/components';
import {useDateTimeFormatter} from 'platform/locale';

import {isNotNil} from 'ramda';

import {RentedOrderResponseBody} from '@dms/api/rental';
import i18n from '@dms/i18n';
import {rentalOrderRoutes} from '@dms/routes';

import {composePath, Nullish, parseDate, TestIdProps, useNavigate} from 'shared/web';

interface NotRentableVehicleAlertProps extends TestIdProps {
  rentedOrder: RentedOrderResponseBody | Nullish;
}

export function NotRentableVehicleAlert(props: NotRentableVehicleAlertProps) {
  const formatDateTime = useDateTimeFormatter();
  const navigate = useNavigate();
  const alertHyperlinks: Hyperlink[] = isNotNil(props.rentedOrder)
    ? [
        {
          title: i18n.t('page.rentalOrder.labels.goToRentalOrder'),
          onClick: () =>
            navigate(
              composePath(rentalOrderRoutes.vehicleAndCustomer, {
                params: {id: props.rentedOrder!.rentalOrderId},
              })
            ),
        },
      ]
    : [];

  const notRentableMessage = isNotNil(props.rentedOrder)
    ? i18n.t('page.rentalOrder.labels.notRentableVehicle', {
        number: props.rentedOrder.number,
        from: formatDateTime('dateTimeShort', parseDate(props.rentedOrder.rentalPeriod.from)),
        to: formatDateTime('dateTimeShort', parseDate(props.rentedOrder.rentalPeriod.to)),
      })
    : i18n.t('page.rentalOrder.labels.notRentableVehicleGeneral');

  return (
    <Alert
      variant="warning"
      title={i18n.t('page.rentalOrder.labels.notRentableVehicleTitle')}
      message={notRentableMessage}
      hyperlinks={alertHyperlinks}
    />
  );
}
